import React from 'react';
import '../styles/experience.css';

const Education = () => {
    const educationEntries = [
        {
            institution: 'Lambton College',
            location: 'Mississauga, Ontario, Canada',
            degree: 'Postgraduate Degree in Big Data Analytics',
            dates: 'Aug 2023 – May 2025'
        },
        {
            institution: 'Nepal Commerce Campus, Tribhuvan University',
            location: 'Kathmandu, Nepal',
            degree: 'Bachelors in Information Management',
            dates: 'Nov 2016 – Sep 2021'
        }
    ];

    return (
        <div className="education-content">
            {educationEntries.map((entry, index) => (
                <div key={index} className="education-item">
                    <div className="education-header">
                        <h3>{entry.institution}</h3>
                        <span>{entry.location}</span>
                    </div>
                    <h4>{entry.degree}</h4>
                    <p className="experience-dates">{entry.dates}</p>
                </div>
            ))}
        </div>
    );
};

export default Education;
